<app-menu [moduloEnum]="moduloEnum" [funcionalidadeEnum]="funcionalidadeEnum"></app-menu>

<div class="container">
  <form class="form" [formGroup]="model" (ngSubmit)="submit()">
    <div class="row empresa-header-row align-items-start">
      <div class="col-auto">
        <button type="button" class="empresa-logo-card" [class.has-logo]="logoUrlPreview" (click)="abrirDialogLogo()">
          @if (logoUrlPreview) {
          <img [src]="logoUrlPreview" alt="Logo da empresa" />
          } @else {
          <div class="logo-empty">
            <mat-icon>image</mat-icon>
            <small>Logo</small>
          </div>
          }
          <div class="logo-overlay">
            <mat-icon>edit</mat-icon>
          </div>
        </button>
      </div>
      <div class="col">
        <h1 class="title-default">Empresas</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <mat-slide-toggle formControlName="isAtivo">
          Empresa {{ model.get('isAtivo')?.value === true ? 'Ativa' : 'Inativa' }}
        </mat-slide-toggle>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline">
          <mat-label>Nome</mat-label>
          <input matInput formControlName="nomeEmpresa" type="text" />
          <mat-icon class="material-icons-outlined" matSuffix
            matTooltip="O nome será usado para identificar a empresa">info_outline</mat-icon>
          @if (model.get('nomeEmpresa')?.invalid) {
          <mat-error>Informe um nome válido</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline">
          <mat-label>CNPJ</mat-label>
          <input matInput formControlName="cnpj" type="text" [mask]="masks.cnpj" />
          @if (model.get('cnpj')?.invalid) {
          <mat-error>Informe um CNPJ válido</mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6 col-lg-4">
        <app-select-pesquisavel label="Fuso-horário" [control]="listaTimezoneControl" [offlineList]="listTimezone"
          [idField]="'idTimezone'" [nameField]="'nome'" [preloadedOptions]="this.preloadedTimezone">
        </app-select-pesquisavel>
      </div>
      <div class="col-12 col-md-6 col-lg-4">
        <app-select-pesquisavel label="Grupo de Empresas" [control]="idEmpresaGrupoControl"
          [apiUrl]="urlListEmpresaGrupo" [preloadedOptions]="preloadedGrupoEmpresa" [idField]="'idEmpresaGrupo'"
          [nameField]="'nomeEmpresaGrupo'" [isOptional]="true">
        </app-select-pesquisavel>
      </div>
      <div class="col-12 col-md-6 col-lg-4">
        <app-select-pesquisavel label="Revenda" [control]="idRevendaControl" [apiUrl]="urlListRevenda"
          [preloadedOptions]="preloadedRevenda" [idField]="'idRevenda'" [nameField]="'nome'" [isOptional]="true">
        </app-select-pesquisavel>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline">
          <mat-label>Nome fantasia</mat-label>
          <input matInput formControlName="nomeFantasia" type="text" maxlength="100" />
          @if (model.get('nomeFantasia')?.hasError('maxlength')) {
          <mat-error>O nome fantasia deve ter no máximo 100 caracteres.</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline">
          <mat-label>Data de fundação</mat-label>
          <input matInput [matDatepicker]="pickerFundacao" [max]="dataMaxima" formControlName="dataFundacao"
            placeholder="dd/mm/aaaa" />
          <mat-datepicker-toggle matIconSuffix [for]="pickerFundacao"></mat-datepicker-toggle>
          <mat-datepicker #pickerFundacao></mat-datepicker>
          @if (model.get('dataFundacao')?.hasError('matDatepickerMax')) {
          <mat-error>A data de fundação não pode ser futura.</mat-error>
          } @else if (model.get('dataFundacao')?.hasError('matDatepickerParse')) {
          <mat-error>Informe uma data válida.</mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    @if (_listaModulos) {
    <div class="row">
      <div class="col-md-4">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Modulos disponiveis para empresa</mat-label>
          <mat-select formControlName="listaIdModulos" multiple>
            @for (modulo of _listaModulos; track modulo) {
            @if (modulo.isDefault) {
            <mat-option [value]="modulo.idModulo" disabled>
              <div style="line-height: 1.2; padding: 4px 0">
                <div>{{ modulo.nome }}</div>
                <small style="color: #666; font-size: 11px">Modulo padrão</small>
              </div>
            </mat-option>
            } @else {
            @if (modulo.codigoProdutoAts) {
            <mat-option [value]="modulo.idModulo" disabled>
              <div style="line-height: 1.2; padding: 4px 0">
                <div>{{ modulo.nome }}</div>
                <small style="color: #666; font-size: 11px">Produto controlado pelo resulth {{ modulo.codigoProdutoAts
                  }}</small>
              </div>
            </mat-option>
            } @else {
            <mat-option [value]="modulo.idModulo">{{ modulo.nome }}</mat-option>
            }
            }
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    }

    <div class="col-12">
      <h1 class="subtitle-default">Dados Fiscais</h1>
    </div>

    <div class="row">
      <div class="col-12 col-md-6 col-lg-4">
        <app-select-pesquisavel label="Regime de tributação" [control]="idRegimeTributarioControl"
          [offlineList]="listaRegimeTributario" [idField]="'id'" [nameField]="'descricao'" [isOptional]="true">
        </app-select-pesquisavel>
      </div>

      <!--
        A apuração do IRPJ (Lucro Real / Lucro Presumido) existe no Regime Normal e no Simples Nacional
        com excesso de sublimite. Trocar o regime limpa o campo, e o envio zera a apuração nos demais.
      -->
      @if (usaRegimeApuracao) {
        <div class="col-12 col-md-6 col-lg-4">
          <app-select-pesquisavel label="Regime de apuração" [control]="idRegimeApuracaoIrpjControl"
            [offlineList]="listaRegimeApuracaoIrpj" [idField]="'id'" [nameField]="'descricao'" [isOptional]="true">
          </app-select-pesquisavel>
        </div>
      }
    </div>

    <div class="row">
      <div class="col-12 col-md-6 col-lg-4">
        <app-select-pesquisavel label="Situação da Inscrição Estadual" [control]="idSituacaoContribuinteEmpresaControl"
          [offlineList]="listaSituacaoContribuinteEmpresa" [idField]="'id'" [nameField]="'descricao'">
        </app-select-pesquisavel>
        <p class="texto-ajuda">{{ ajudaSituacaoContribuinteEmpresa }}</p>
      </div>

      <div class="col-12 col-md-6 col-lg-4">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Inscrição Estadual</mat-label>
          <input matInput formControlName="inscricaoEstadual" type="text" />
          @if (model.get('inscricaoEstadual')?.hasError('required')) {
          <mat-error>Informe a Inscrição Estadual.</mat-error>
          } @else {
          <mat-hint>{{ ajudaInscricaoEstadual }}</mat-hint>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6 col-lg-4">
        <app-select-pesquisavel label="CNAE Principal" [control]="cnaePrincipalControl" [apiUrl]="cnaeLookupUrl"
          [preloadedOptions]="preloadedCnae" [idField]="'codigo'" [nameField]="'descricao'" [isOptional]="true">
        </app-select-pesquisavel>
      </div>

      <div class="col-12 col-md-6 col-lg-4">
        <mat-form-field appearance="outline">
          <mat-label>Inscrição Municipal</mat-label>
          <input matInput formControlName="inscricaoMunicipal" type="text" />
        </mat-form-field>
      </div>

      <div class="col-12 col-md-6 col-lg-4">
        <mat-form-field appearance="outline">
          <mat-label>Inscrição SUFRAMA</mat-label>
          <input matInput formControlName="inscricaoSuframa" type="text" />
        </mat-form-field>
      </div>
    </div>

    @if (isContribuinteExclusivoIbsCbs) {
    <div class="card-enquadramento">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <div>
        <strong>O que muda com esse enquadramento</strong>
        <ul>
          @for (frase of frasesEnquadramentoContribuinteExclusivoIbsCbs; track frase) {
          <li>{{ frase }}</li>
          }
        </ul>
      </div>
    </div>
    }

    <div class="col-12">
      <h1 class="subtitle-default">Usuário master</h1>
    </div>

    @if (this.idEmpresa) {
    <div class="col-12">
      <mat-slide-toggle formControlName="alterarMaster" (change)="changeMaster()">
        Alterar Master
      </mat-slide-toggle>
    </div>
    }

    <div class="row">
      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" type="email" />
          <mat-icon class="material-icons-outlined" matSuffix
            matTooltip="O email será usado para realizar login e não pode ser alterado após a criação do usuário">info_outline</mat-icon>
          @if (model.get('email')?.invalid) {
          <mat-error>Informe o e-mail</mat-error>
          }
        </mat-form-field>
      </div>
      @if (model.get('alterarMaster')?.value || !idEmpresa) {
      <div class="col-md-6">
        <button type="button" mat-flat-button class="btn-primary button-pesquisa" (click)="buscarPorEmail()">
          @if (_isLoadingBusca === true) {
          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
          } @else {
          Buscar Email
          }
        </button>
      </div>
      }
    </div>

    <div class="row">
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline">
          <mat-label>Nome</mat-label>
          <input matInput formControlName="nomeUsuario" type="text" />
          @if (model.get('nomeUsuario')?.invalid) {
          <mat-error>Informe o nome</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-12 col-sm-6 col-md-4">
        <mat-form-field appearance="outline">
          <mat-label>CPF</mat-label>
          <input matInput formControlName="cpf" type="text" [mask]="masks.cpf" />
        </mat-form-field>
      </div>
      <div class="col-12 col-sm-6 col-md-4">
        <mat-form-field appearance="outline">
          <mat-label>Telefone</mat-label>
          <input matInput formControlName="telefone" type="text" [mask]="masks.phone" />
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-sm-6 col-md-4">
        <mat-form-field appearance="outline">
          <mat-label>Senha temporária</mat-label>
          <input matInput [type]="hide() ? 'password' : 'text'" formControlName="senha" />
          <button type="button" mat-icon-button matSuffix (click)="clickEvent($event)"
            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide()">
            <mat-icon>{{ hide() ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          @if (model.get('senha')?.invalid) {
          <mat-error>Informe a sua senha</mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <h1 class="subtitle-default">Casas decimais</h1>
      </div>
      <div class="col-6 col-md-4">
        <mat-form-field appearance="outline">
          <mat-label>Número de casas decimais na quantidade</mat-label>
          <input matInput formControlName="casasDecimaisQuantidade" type="text" [mask]="'99'" min="2" max="4" />
          @if (model.get('casasDecimaisQuantidade')?.invalid) {
          <mat-error>Informe um número entre 2 e 4</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-6 col-md-4">
        <mat-form-field appearance="outline">
          <mat-label>Número de casas decimais no preço</mat-label>
          <input matInput formControlName="casasDecimaisPreco" type="text" [mask]="'99'" min="2" max="10" />
          @if (model.get('casasDecimaisPreco')?.invalid) {
          <mat-error>Informe um número entre 2 e 10</mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <h1 class="subtitle-default">Endereço</h1>
      </div>

      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>CEP</mat-label>
          <input matInput formControlName="cep" type="text" [mask]="masks.cep" (blur)="buscarCep()" />
          <mat-spinner class="inline-loading" matSuffix [diameter]="20" [hidden]="!isLoadingCep"></mat-spinner>
          <mat-icon matSuffix [hidden]="isLoadingCep" (click)="buscarCep()" style="cursor: pointer">search</mat-icon>
          @if (model.get('cep')?.hasError('required')) {
          <mat-error>Informe o CEP</mat-error>
          } @else if (model.get('cep')?.hasError('pattern')) {
          <mat-error>Informe um CEP válido</mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline">
          <mat-label>Logradouro</mat-label>
          <input matInput formControlName="logradouro" type="text" />
          @if (model.get('logradouro')?.invalid) {
          <mat-error>Informe o logradouro</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-12 col-md-2">
        <mat-form-field appearance="outline">
          <mat-label>Número</mat-label>
          <input matInput formControlName="numero" type="text" />
          @if (model.get('numero')?.invalid) {
          <mat-error>Informe o número</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline">
          <mat-label>Complemento</mat-label>
          <input matInput formControlName="complemento" type="text" />
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline">
          <mat-label>Bairro</mat-label>
          <input matInput formControlName="bairro" type="text" />
          @if (model.get('bairro')?.invalid) {
          <mat-error>Informe o bairro</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-12 col-md-3">
        <app-select-pesquisavel label="UF" [control]="idUnidadeFederativaControl"
          [offlineList]="_listaUnidadeFederativa" [idField]="'idUnidadeFederativa'" [nameField]="'descricaoExibicao'"
          [preloadedOptions]="this.preloadedUnidadeFederativa" errorMessage="Informe a UF"
          (selectionChange)="changeUnidadeFederativa($event)">
        </app-select-pesquisavel>
      </div>

      <div class="col-12 col-md-5">
        <app-select-pesquisavel label="Município" [control]="idMunicipioControl" [apiUrl]="urlListMunicipio"
          [idField]="'idMunicipio'" [nameField]="'nome'" [preloadedOptions]="preloadedMunicipio"
          errorMessage="Informe o município">
        </app-select-pesquisavel>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-sm-6 col-md-3">
        <button type="submit" mat-flat-button class="btn-primary button-big" [disabled]="disableSave">
          @if (_isLoading === true) {
          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
          } @else {
          Salvar
          }
        </button>
      </div>
    </div>
  </form>
</div>